import { logError } from 'utils/logger';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/trnsact-scorecard-sdk';
import { CriteriaValue } from '../types';
import { determineNumberValue } from './determineNumberValue';

export function mapCriteriaToConditions(conditions: CriteriaValue[]): any[] {
  return conditions.map(condition => {
    let conditionToReturn;

    if (condition.fact in FACT_NAMES_NUMERIC) {
      const parsedMinValue = determineNumberValue(condition.number.min);
      const parsedMaxValue = determineNumberValue(condition.number.max);

      conditionToReturn = {
        fact: condition.fact,
        minValue: parsedMinValue || parsedMinValue === 0 ? String(parsedMinValue) : null,
        maxValue: parsedMaxValue || parsedMaxValue === 0 ? String(parsedMaxValue) : null,
        exactMatch: undefined,
      };
    }

    if (condition.fact in FACT_NAMES_STRING) {
      conditionToReturn = {
        fact: condition.fact,
        exactMatch: (condition.string?.value ?? [])
          .map((stringValue: any) => {
            if (typeof stringValue === 'string') {
              return stringValue;
            }

            if ('value' in stringValue) {
              return stringValue.value;
            }

            logError('[mapCriteriaToConditions] Issue with criteria stringValue', stringValue);

            return '';
          })
          .filter(Boolean),
      };
    }

    if (condition.fact in FACT_NAMES_BOOLEAN) {
      conditionToReturn = {
        fact: condition.fact,
        value: condition.boolean.value,
        exactMatch: undefined,
      };
    }

    if (!conditionToReturn) {
      throw new Error(`Unexpected fact type: ${condition.fact}`);
    }

    if (condition.score) {
      conditionToReturn = {
        ...conditionToReturn,
        score: condition.score,
      };
    }

    return conditionToReturn;
  });
}
